<app-loading></app-loading>
<mat-sidenav-container>
  <div [ngClass]="infoBannerClass" *ngIf="!infoDialogShow && infoRouteShow && !showBannerdForBrand">
    <img class="info-icon" src="./assets/icons/info-icon.svg" alt="">
    <div class="info-container">
      <div class="title">
        AVISO IMPORTANTE
      </div>
      <div class="text">
        Hemos&nbsp;actualizado&nbsp;nuestro&nbsp;<u (click)="goToTerms()" data-test="app-link-terms">Aviso de Privacidad</u>. Conoce&nbsp;como&nbsp;protegemos&nbsp;tus&nbsp;datos por&nbsp;ser&nbsp;parte&nbsp;del&nbsp;club!.
      </div>
    </div>
    <mat-icon class="close-icon" svgIcon="close" (click)="closeInfoBanner()" data-test="app-btn-closeBanner"></mat-icon>
  </div>

  <div class="secure-banner cero-padding">
    <div class="title">
      TU SEGURIDAD ES LO MÁS IMPORTANTE:
    </div>
    <img src="./assets/homepage/app/alert.svg" alt="alert" class="alert-icon">
    <div class="message">
      A Comer Club nunca te pedirá datos bancarios, NIP, contraseñas o códigos por SMS, WhatsApp,<br>redes sociales o sitios externos. <span>Realiza cualquier consulta o beneficio únicamente desde nuestros canales oficiales.</span>
    </div>
  </div>

  <button mat-fab class="scroll-fab-btn" [ngClass]="{ 'second-btn': chatBtnLoaded }" (click)="scrollToTop()">
    <img src="./assets/icons/scroll-up.svg">
  </button>

  <img class="d-none d-lg-block gradiant-img" [ngClass]="{'scrollDown': !scrollDown}" src="./assets/header-footer/transparencia_header_menu.png" alt="" *ngIf="!errorMenu && !callcenterMenu  && !mobileMenu && !qrMenu && !showBannerdForBrand">
  <mat-toolbar *ngIf="!errorMenu && !callcenterMenu && !mobileMenu && !qrMenu && !showBannerdForBrand">
    <mat-toolbar-row class="navigation-bar-mb d-flex d-sm-flex d-md-flex d-lg-none d-xl-none" [ngClass]="{'scrollDown': !scrollDown}">
      <button mat-icon-button (click)="sidenav.toggle()" class="d-block d-sm-block d-md-block d-lg-none d-xl-none" data-test="app-btn-menuMobile">
        <mat-icon svgIcon="menu"></mat-icon>
      </button>
      <div class="logo-header">
        <img class="acomer-logo-mobile" src="./assets/header-footer/logo_acomer_club_header.svg" alt="">
        <img class="aniv-logo-mobile" src="./assets/header-footer/aniversary.png" alt="">
      </div>
    </mat-toolbar-row>

    <mat-toolbar-row class="navigation-bar d-none d-lg-flex" [ngClass]="{'scrollDown': !scrollDown}">
      <div class="col-lg-3 d-none d-lg-block logo-col">
        <a class="logo-col" routerLink="home" fragment="main" data-test="app-link-home">
          <img class="acomer-logo" src="./assets/header-footer/logo_acomer_club_header.svg" alt="">
          <img class="aniv-logo" src="./assets/header-footer/aniversary.png" alt="">
        </a>
      </div>

      <div class="button-cols col-lg-9 d-none d-lg-flex">
        <div class="header-buttons" *ngFor="let button of objButtons">
          <button mat-button class="toogle-button" routerLink="home" fragment={{button.id}} data-test="app-btn-nav">{{button.name}}</button>
          <div class="division" *ngIf="button.id !== 'locations'"></div>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav #sidenav class="side-menu">
    <mat-nav-list class="side-menu">
      <div>
        <a mat-list-item (click)="sidenav.toggle()" routerLink="home" fragment="main" data-test="app-link-mobileHome">
          <img src="./assets/header-footer/icon_home.svg" alt="">Home
        </a>
        <a mat-list-item (click)="sidenav.toggle()" *ngFor="let button of objButtons" routerLink="home" fragment={{button.id}} data-test="app-link-mobileNav">
          <img src="{{button.icon}}" alt="">{{button.name}}
        </a>
      </div>
    </mat-nav-list>
  </mat-sidenav>

  <div class="main-container">
    <router-outlet></router-outlet>

    <div class="footer" id="footer" *ngIf="!showBannerdForBrand">
      <app-footer></app-footer>
    </div>
  </div>
</mat-sidenav-container>
